// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"e48752f6","769":"1d07a7b7"}[chunkId] + ".chunk.js";
};